import { combineReducers } from "redux";
import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const markersFetchingReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_MARKERS_REQUEST:
      return true;
    case types.FETCH_MARKERS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const markersAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_MARKERS_SUCCESS:
      return action.data.result;
    case types.FETCH_MARKER_SUCCESS:
    case types.CREATE_MARKER_SUCCESS:
    case types.UPDATE_MARKER_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [action.data.result, ...state]
        : state;
    case types.DELETE_MARKER_SUCCESS:
    case types.DELETE_AND_MERGE_MARKER_SUCCESS:
      return state.filter(id => id !== action.globalId);
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const markersByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_MARKERS_SUCCESS:
      return action.data.entities.markers;
    case types.FETCH_MARKER_REQUEST:
    case types.UPDATE_MARKER_REQUEST:
    case types.DELETE_MARKER_REQUEST:
    case types.DELETE_AND_MERGE_MARKER_REQUEST:
      return {
        ...state,
        [action.globalId]: { ...state[action.globalId], isFetching: true }
      };
    case types.FETCH_MARKER_SUCCESS:
    case types.CREATE_MARKER_SUCCESS:
    case types.UPDATE_MARKER_SUCCESS:
      return { ...state, ...action.data.entities.markers };
    case types.DELETE_MARKER_SUCCESS:
    case types.DELETE_AND_MERGE_MARKER_SUCCESS:
      const newById = state;
      delete newById[action.globalId];
      return newById;
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const colorOptionsReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_MARKERS_SUCCESS:
      return action.colorOptions;
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const markersReducer = combineReducers({
  isFetching: markersFetchingReducer,
  all: markersAllReducer,
  byId: markersByIdReducer,
  colorOptions: colorOptionsReducer
});

export default markersReducer;
